export default "__VITE_ASSET__InOJXQ2l__"